function BootstrapError() {
  return (
    <div style={{ padding: '2rem', fontFamily: 'sans-serif' }}>Something went wrong. Please refresh the page.</div>
  );
}

export default BootstrapError;
